import {Component, ElementRef, EventEmitter, input, Input, Output, ViewChild} from '@angular/core';
import {Subsidy} from '../../../models/subsidy.model';
import {AttachmentsService} from '../../../services/attachments/attachments.service';
import {AttachmentType} from '../../../services/attachments/attachment-type.enum';
import {Attachment} from '../../../services/attachments/attachment.model';
import {LoadingService} from '../../services/loading/loading.service';
import {SubsidiesStore} from '../../../services/subidies/subsidies.store';

@Component({
	selector: 'tvsub-attachment-box',
	templateUrl: './attachment-box.component.html',
	styleUrls: ['./attachment-box.component.scss'],
	standalone: false
})
export class AttachmentBoxComponent {
	@Input()
	attachmentId: number;
	@Input()
	showErrors: boolean;
	@Input()
	subsidy: Subsidy;
	@Output()
	uploaded: EventEmitter<Attachment> = new EventEmitter();
	@Output()
	remove: EventEmitter<void> = new EventEmitter();
	@ViewChild('uploadButton')
	uploadButton: ElementRef;

	step = input.required<number>();
	type = input.required<AttachmentType>();

	errorMessage: string | null;

	constructor(private attachmentsService: AttachmentsService, private loadingService: LoadingService, private subsidiesStore: SubsidiesStore) {}

	get attachment(): Attachment | null {
		if (this.attachmentId) {
			return this.subsidy.attachments.find((a) => a.id === this.attachmentId) || null;
		}

		return null;
	}

	get hasError(): boolean {
		return this.showErrors && !this.attachmentId;
	}

	getAttachment(): Attachment | null {
		if (this.attachmentId) {
			return this.subsidy.attachments.find((a) => a.id === this.attachmentId) || null;
		}

		return null;
	}

	doRemove() {
		this.remove.emit();
	}

	handleFileInput(files: FileList) {
		this.errorMessage = null;

		if (files && files.length) {
			const file = files.item(0);

			if (file) {
				const exists = !!this.subsidy.attachments.find((a) => a.filename === file.name);

				if (exists) {
					this.errorMessage = `Er bestaat al reeds een bijlage: ${file.name}`;
					return;
				}

				const error = this.attachmentsService.checkFileName(file!);

				if (error) {
					this.errorMessage = error;
					return;
				}

				this.loadingService.load('Bezig met uploaden... Even geduld aub.');

				this.attachmentsService.uploadAttachment(this.subsidy.type, this.subsidy.id, file, this.type()).subscribe({
					next: (attachment) => {
						this.subsidiesStore.updateSubsidy(this.subsidy.id, {
							...this.subsidy,
							attachments: [...this.subsidy.attachments, attachment],
							currentFrontendStep: this.step(),
						});

						this.uploaded.emit(attachment);
						this.loadingService.done();
					},
					error: (err) => {
						console.log(err);
						this.loadingService.done();
					},
				});
			}
		}
	}

	selectFile() {
		this.uploadButton.nativeElement.click();
	}
}
